import { BrowserRouter as Router } from 'react-router-dom';

import { Navbar } from "./components";
import { Pages } from './pages';
import './app.scss';

function App() {
	return (
		<div className='App' id='app'>
			<Router>
				<Navbar/>
				<Pages />
			</Router>
		</div>
	);
}

export default App;
